<template>
  <div>
      <div class="corporate-sustainability">
          <div class="cursor hide">
                 <svg class="arrow-svg" fill="green"  xmlns="http://www.w3.org/2000/svg" width="26.176" height="12.679" viewBox="0 0 26.176 12.679">
                    <use xlink:href="#cursor-arrow"></use>
                </svg>
            </div> 
          <Header></Header>
          <Corporate :corporate="this.data.corporate" />
          <Sustainability :sustainability="this.data.sustainability" />  
          <Activityslider />
          <Climate :climate="this.data.climate" />
          <Sociabusiness :socialbusiness="this.data.socialbusiness" />
          <Inclusivity :inclusivity="this.data.inclusivity" />
          <GenerationYouth :generationyouth="this.data.generationyouth" />
          
      </div>
  </div>
</template>

<script>
import data from '@/components/coporate-sustainability/json/data';
export default {
    data(){
        return{
            data:data
        }
    },
    created(){
        if(this.$i18n.locale=="en"){
            this.data = this.data.en;
        }
        else{
            this.data = this.data.ar;
        }
    },
    components:{
       Corporate :() => import("@/components/coporate-sustainability/coporate"),
       Sustainability :() => import("@/components/coporate-sustainability/sustainability"),
       Activityslider :() => import("@/components/coporate-sustainability/activitysliders"),
       Climate :() => import("@/components/coporate-sustainability/climate") ,
       Sociabusiness :() => import("@/components/coporate-sustainability/sociabusiness") ,
       Inclusivity :() => import("@/components/coporate-sustainability/inclusivity") ,
       GenerationYouth :() => import("@/components/coporate-sustainability/generationYouth") ,
    },
}
</script>
<style lang="scss" >
    .corporate-sustainability{
        position: relative;
        .cursor{
        // position: fixed;
        height: 100px;
        width: 100px;
        background: #fff;
        transform: rotate(45deg);
        box-shadow: 0px 0px 4px 1px #222121;
        z-index: 1;
        position: absolute;
        top:0px;
        z-index: 999;
        .arrow-svg{
            height: 35px;
            width: 38px;
            fill: #04A975;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(316deg);
        }
        .rotateMe{
            transform: translate(-50%, -50%) rotate(135deg);
        }
        @media screen and (max-width: 991px) {
            .cursurControl {
                display: none!important;
            }
        }
        /deep/ .hooper-navigation {
            @media screen and (min-width: 992px) {
                display: none!important;
            }
        }
    }
    .hide{
            display: none;
        }
        img{
            max-width: 100%;
            height: auto;
        }
        .section{
            >div{
                padding-top:rem(70px);
            }
            &.section_one{
                >div{
                    padding-top: rem(100px);
                }
            }
            p,ul{
                padding-top: rem(30px);
                margin: unset;
                color: #fff;
                font-size: rem(18px);
                line-height: 1.5;
            }
            .pt-40{
                padding: unset;
                padding-top: 40px;
            }
            .mt-50{
                margin-top: 50px;
            }
            position: relative;
            padding-bottom: rem(55px);
            &::before{
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.3);
                z-index: -1;
            }
            
            .custom_border{
                position: relative;
                max-width: 500px;
                margin-left: auto;
                margin-right: auto;  
                ul{
                    list-style: none;
                    li{
                        position: relative;
                        padding-left: 30px;
                        margin-bottom: 5px;
                        &::before{
                            content: '';
                            position: absolute;
                            width: 10px;
                            height: 10px;
                            left: 0;
                            background: hsla(161, 93%, 34%, 1);
                            background: radial-gradient(circle, hsla(161, 93%, 34%, 1) 70%, hsla(0, 0%, 100%, 0.6) 100%);
                            background: -moz-radial-gradient(circle, hsla(161, 93%, 34%, 1) 70%, hsla(0, 0%, 100%, 0.6) 100%);
                            background: -webkit-radial-gradient(circle, hsla(161, 93%, 34%, 1) 70%, hsla(0, 0%, 100%, 0.6) 100%);
                            border-radius: 50%;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
                &::before{
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 4px;
                    background: #06A976;
                    @media screen and (max-width:767px){
                        width: calc(100% - 30px);
                    }
                }
                @media screen and (max-width:767px){
                    max-width:100%;
                    padding:0 15px;
                }
            }

            .full-content {
                .custom_border {
                    max-width: 100%!important;
                    &:before {
                        content: none;
                    }
                    h5 {
                        color: #ffffff;
                        font-size: rem(28px);
                        margin-top: rem(35px);
                        font-weight: 700;
                    }
                }
            }
            // .scroll_icon{
            //     display: flex;
            //     align-items: center;
            //     .text{
            //         flex: 1;
            //     }
            //     .icon{
            //         flex: 0 0 50px;
            //     }
            // }
            
        } 
        .bottom-wrapper {
            display: flex;
            align-items: center;
            position: relative;
            @media screen and (max-width:991px) {
                display: block;
            }
            .bottom-txt {
                color: #ffffff;
                font-size: rem(25px);
                font-weight: 700;
                line-height: 1.25;
            }
        }
        .scroll_icon {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            @media screen and (max-width:991px) {
                position: static;
                left: unset;
                bottom: unset;
                transform: unset;
                margin-top:25px;
            }
            .scroll-svg {
                width: 40px;
                height: 40px;
                color: #fff;
            }
            .scroll_svg_section {
                display: flex;
                align-items: center;
                cursor: pointer;
                @media screen and (max-width:991px){
                    justify-content: center;
                }
                svg {
                    transition: 0.5s ease;
                }
                &:hover {
                    svg {
                        transform: scale(1.2);
                    }
                }
            }
            .scroll-text {
                font-size: 20px;
                font-weight: bold;
                margin-right: 20px;
                color: #fff;
                text-transform: uppercase;
                @media (max-width: 991px) {
                    font-size: 17px;
                }
            }
        }
        
        .hooper {
            height: auto;
            .hooper-slide {
                &:not(.is-current) {
                    .main_card {
                        transform: scale(.8);
                        transform-origin: left center;
                        transition: 0.5s all;
                    }
                }
            }
        }
        
        .main_slider {
            padding-top: 80px;
            padding-bottom: 50px;
            position: relative;
            .main_card {
                display: flex;
                align-items: center;
                .scrollWrapper{
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;  /* Firefox */
                    &::-webkit-scrollbar{
                        opacity:0 !important;
                        display:none !important;
                    }
                }
                @media screen and (max-width:1600px) {
                    // justify-content: center;
                }
                .image {
                    @media screen and (max-width:1200px) and (min-width:991px) {
                        display: flex;
                        justify-content: flex-end;
                    }
                    img {
                        @media screen and (max-width:1600px) {
                            max-width:80%;
                        }
                        @media screen and (max-width:991px) {
                            display:none;
                        }
                    }
                }
                .desc {
                    background-color: #ffffff;
                    padding: rem(15px) rem(45px) rem(15px);
                    color: #000000;
                    flex: 0 0 615px;
                    margin-left: -210px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 570px;
                    
                     @media screen and (max-width:1600px) {
                        flex: 0 0 540PX;
                        height: 470px;
                        padding: rem(15px) rem(30px) rem(15px);
                        margin-left: -320px;
                    }
                    @media screen and (max-width:991px) {
                        flex: 0 0 450px;
                        height: 420px;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    @media screen and (max-width:1200px) and (min-width:993px) {
                        flex: 0 0 450px;
                         margin-left: -330px !important;
                    }
                    @media screen and (max-width:500px) {
                        flex: 0 0 350px;
                        height: 470px;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    .country {
                        display: flex;
                        align-items: center;
                        text-transform: uppercase;
                        padding-bottom: rem(30px);
                        border-bottom: 3px solid #00A773;
                        margin-bottom: rem(35px);
                        font-size: rem(50px);
                        font-weight: 700;
                        color: #505050;
                        @media screen and (max-width:1600px) {
                            font-size: rem(30px);
                        }
                        .flag {
                            margin-right: rem(30px);
                            max-width: 76px;
                            img {
                                max-width: 100%;
                            }
                            @media screen and (max-width:1600px) {
                                max-width: 55px;    
                            }
                        }
                    }
                    ul {
                        color: #505050;
                        list-style: none;
                        padding: 0;
                        li {
                            font-size: rem(20px);
                            span {
                                color: #00A773;
                            }
                            ul {
                                margin-top: rem(25px);
                            }
                        }
                        &.round-circle {
                            
                            > li {
                                position: relative;
                                padding-left: 15px;
                                &:not(:last-child) {
                                    margin-bottom: rem(25px);
                                }
                                &:before {
                                    position: absolute;
                                    content: '';
                                    width: 7px;
                                    height: 7px;
                                    background-color: #00A773;
                                    left: 0;
                                    top: 7px;
                                    border-radius: 100px;
                                }
                            }
                        }
                    }
                }
                .scrollWrapper {
                    height: calc(100% - (145px));
                    ul {
                        padding-right: 15px;
                        @media screen and (max-width:500px) {
                            padding-right: 30px;
                        }
                    }
                }
            }
            .activity__counter {
                color: #ffffff;
                font-size: rem(20px);
                @include flex (center, start);
                display: inline-flex;
                top: 0;
                // top: 50%;
                // transform: translateY(-50%);
                position: absolute;
                @media screen and (max-width:991px) {
                    position: static;
                }
                span {
                    font-size: rem(60px);
                    padding-right: 8px;
                    font-weight: 700;
                }
            }
        }

        .cursurControl{
        //    .d-flex{
        //        position:absolute;
        //        bottom: 0;
        //        left: 0;
        //        .w-50{
        //            z-index: 99;
        //        }
        //    }
            .slider-nav{
                width: 25%;
                position:absolute;
                bottom: 75px;
                height: 75%;
                &#left{
                    left: 0;
                }
                &#right{
                    left: auto;
                    right: 0;
                    width: 35%;
                }
            }
        }
        .section_three{
        position: relative;
    }
        .section.section_youth.two{
            padding-bottom: unset;
        }
    }
    // arabic
    [lang="ar"] {
        .corporate-sustainability{
            .cursor{
                left: 0;
                .arrow-svg{
                    left: 50%;
                     transform: translate(-50%, -50%) rotate(135deg);
                }
                .rotateMe{
                    transform: translate(-50%, -50%) rotate(316deg);
                }
            
            }
            .section{
            
                
                
                .custom_border{
                    
                    margin-left: auto;
                    margin-right: auto;  
                    ul{
                        li{
                            
                            padding-right: 30px;
                            padding-left: 0;
                            &::before{
                                
                                right: 0; left: auto;
                                
                            }
                        }
                    }
                    
                    @media screen and (max-width:767px){
                        
                        padding-right: 15px;
                        padding-left: 15px;
                    }
                }

                
                
            } 
            .scroll_icon {
            
                // left: 50%;
                // transform: translateX(-50%);
                
                // @media screen and (max-width:991px) {
                
                //     left: unset;
                //     transform: unset;
                    
                // }
                
                .scroll-text {
                    margin-left: 20px; margin-right: 0;
                }
            }
            .main_slider {
                
                .main_card {
                    
                    .desc {
                        padding-right: rem(45px);
                            padding-left: rem(45px);
                        margin-right: -210px; margin-left: auto;
                        
                        
                        @media screen and (max-width:1600px) {
                        
                           
                            padding-right: rem(30px);
                            padding-left: rem(30px);
                            margin-right: -320px;
                            margin-left: 0;
                        }
                        @media screen and (max-width:991px) {
                            
                            margin-left: auto;
                            margin-right: auto;
                        }
                        @media screen and (max-width:1200px) and (min-width:993px) {
                            
                            margin-right: -330px !important;
                            margin-left: 0!important;
                        }
                        @media screen and (max-width:500px) {
                            
                            margin-left: auto;
                            margin-right: auto;
                        }
                        .country {
                            
                            
                            .flag {
                                margin-left: rem(30px);
                                margin-right: 0;
                            }
                        }
                        ul {
                            
                            padding: 0;
                            
                            &.round-circle {
                                
                                > li {
                                    padding-right: 15px;
                                    padding-left: 0;
                                    &:before {
                                        right: 0;
                                        left: auto;
                                    }
                                }
                            }
                        }
                    }
                    .scrollWrapper {
                        ul {
                            padding-left: 15px;
                            padding-right: 0;
                            direction: rtl;
                            @media screen and (max-width:500px) {
                                padding-left: 30px;
                                padding-right: 0;
                            }
                        }
                    }
                }
                .activity__counter {
                    
                    span {
                        padding-left: 8px;
                        padding-right: 0;
                    }
                }
            }
            .cursurControl{
            
                .slider-nav{
                    
                    &#left{
                        right: 0;
                        left: auto;
                    }
                    &#right{
                        right: auto;
                        left: 0;
                    }
                }
            }
            .hooper .hooper-slide:not(.is-current) .main_card {
                transform-origin: right center;
            }
        }
        .ml-auto {
            margin-right: auto !important;
            margin-left: 0 !important;
        }
    }
</style>